import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useT } from "@/i18n/LanguageContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const { t } = useT();
  const nav = useNavigate();
  const { refreshMe } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const oauthError = params.get("error");
      if (oauthError || !code) {
        nav("/login?error=google", { replace: true });
        return;
      }
      try {
        const redirectUri = `${window.location.origin}/auth/callback`;
        const res = await api.post("/auth/google/session", { code, redirect_uri: redirectUri });
        if (res.data?.access_token) setToken(res.data.access_token);
        window.history.replaceState({}, document.title, window.location.pathname);
        await refreshMe();
        nav("/dashboard", { replace: true });
      } catch (e) {
        console.error(e);
        nav("/login?error=google", { replace: true });
      }
    };
    run();
  }, [nav, refreshMe]);

  return (
    <div className="min-h-[70vh] grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#D4AF37] mx-auto" />
        <div className="mt-4 text-white/70">{t.auth?.signingIn || "Signing you in…"}</div>
      </div>
    </div>
  );
};

export default AuthCallback;
